import { client, withDataRequest } from 'utils/client';
import { GetPublicJobBoardResourcesTable, PublicJobBoardResourceTableView } from 'features/hub-posts/types';
import { TableDataResponse } from 'features/types';

const resourcesAPI = {
  getHubPosts(params: GetPublicJobBoardResourcesTable) {
    return client.post<TableDataResponse<PublicJobBoardResourceTableView>>('/resources/get-table', withDataRequest(params));
  },
  getEventsTable(params: GetPublicJobBoardResourcesTable) {
    return client.post<TableDataResponse<PublicJobBoardResourceTableView>>('/resources/get-events-table', withDataRequest(params));
  },
  getProductsServicesTable(params: GetPublicJobBoardResourcesTable) {
    return client.post<TableDataResponse<PublicJobBoardResourceTableView>>('/resources/get-products-services-table', withDataRequest(params));
  },
  getResource(resourceId: string) {
    return client.get<PublicJobBoardResourceTableView>(`/resources/${resourceId}`);
  },
};

export default resourcesAPI;
